(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/kyc.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/kyc.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const routes = svs.myProfile.constants.routes;
const Skeleton = svs.myProfile.react.shared.components.Skeleton;
const defaultTechnicalErrorDialog = svs.myProfile.react.pages.kyc.dialogs.defaultTechnicalErrorDialog;
const Kyc = () => {
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isKycLoaded = _React$useState2[0],
    setIsKycLoaded = _React$useState2[1];
  const kycContainerRef = useRef();
  const history = useHistory();
  const kycErrorCallback = async () => {
    await defaultTechnicalErrorDialog();
  };
  useEffect(() => {
    const onKycCancel = () => {
      history.push(routes.MY_PROFILE_HOME);
    };
    const navigateToQuestions = () => {
      history.push(routes.MY_PROFILE_KYC_QUESTIONS);
    };
    svs.core.module.load('/cl/components/react:kyc', null, () => {
      setIsKycLoaded(true);
      svs.components.kyc.init(kycContainerRef.current, {
        context: void 0,
        onComplete: navigateToQuestions,
        showOverview: true,
        onCancel: onKycCancel,
        onError: kycErrorCallback
      });
    }, false);
  }, [history]);
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, !isKycLoaded && React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 11,
    boxWidthProcent: 100,
    topMargin: 3
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  })), React.createElement("div", {
    className: "padding-top-2",
    ref: kycContainerRef
  }));
};
svs.myProfile.react.pages.kyc.Kyc = Kyc;

 })(window);